import { gql } from '@apollo/client';

export default gql`
  query spacePermissions($page: Int, $name: String, $email: String, $sortBy: String) {
    space {
      adminRole
    }
    spacePermissions(page: $page, email: $email, name: $name, sortBy: $sortBy) {
      hasNextPage
      permissionsTotalPages
      permissionsTotal
      currentPage
      permissions {
        id
        role
        confirmed
        user {
          id
          email
          name
          surname
        }
      }
    }
  }
`;
